'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _lodash = require('lodash');

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import imageLocationMobile from 'assets/img/location/locationMobile.png';
var NearMe = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shops: state.shops.featured,
    province: state.address.province,
    featuredLoading: state.shops.featuredLoading,
    featuredLoaded: state.shops.featuredLoaded,
    isGeoAvailable: state.user.isGeoAvailable,
    coords: state.user.coords
  };
}, (0, _extends3.default)({}, shopActions, filterActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(NearMe, _Component);

  function NearMe() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NearMe);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NearMe.__proto__ || (0, _getPrototypeOf2.default)(NearMe)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pageSize: 5,
      firstLoad: false,
      category: []
    }, _this.handleChangeDiscoverNearby = function (category, seeMore) {
      var linkSeeMore = '/kham-pha';
      // Tracking
      var tracking = _this.props.tracking;

      _this.props.manualTrack((0, _extends3.default)({}, tracking, { button: seeMore ? 'See More' : 'Section Title', label: seeMore ? 'Xem thêm' : _this.props.name }));
      if (category.length > 0) {
        linkSeeMore = linkSeeMore + '?category=' + category.join(',');
        if (!(0, _lodash.isEmpty)(_this.props.coords)) {
          linkSeeMore = linkSeeMore + '&sort=nearby';
        }
      } else if (_this.props.coords && _this.props.coords.latitude && _this.props.coords.longitude) {
        linkSeeMore = linkSeeMore + '?sort=nearby';
      }
      _this.props.changeSortType('nearby');
      _reactRouter.browserHistory.push(linkSeeMore);
      if (seeMore === true) {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked See More',
          label: 'Near Me'
        });
      } else {
        _reactGa2.default.event({
          category: 'Home Section',
          action: 'Clicked Title',
          label: 'Near Me'
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NearMe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.featuredLoaded && this.props.featuredLoading !== true) {
        this.getResult.call(this);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.featuredLoading) {
        this.setState({ firstLoad: true });
      }
      // if (!isEqual(this.props.shops, nextProps.shops)) {
      //   this.props.getOffset();
      // }
      if (!(0, _lodash.isEqual)(nextProps.coords, this.props.coords) && !this.props.isGeoAvailable && nextProps.isGeoAvailable) {
        this.getResult.call(this, nextProps.coords);
      }
      if (nextProps.province !== this.props.province) {
        this.getResult.call(this, null, nextProps.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult(coords, province) {
      var filter = {
        pageSize: this.state.pageSize,
        category: this.state.category.join(','),
        province: province ? province : this.props.province,
        location: coords ? coords : this.props.coords
      };
      this.props.getFeatured(filter);
    }
  }, {
    key: 'isActiveCategory',
    value: function isActiveCategory(cat) {
      return this.state.category.length === 0 || this.state.category.indexOf(cat) !== -1;
    }
  }, {
    key: 'activeCategory',
    value: function activeCategory(cat) {
      var category = [cat];
      if (this.state.category.indexOf(cat) !== -1) {
        category = [];
      }
      this.setState({ category: category });
      this.props.getFeatured({
        category: category.join(','),
        province: this.props.province,
        location: this.props.coords
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          shops = _props.shops,
          slogan = _props.slogan,
          coords = _props.coords,
          banners = _props.banners;
      var _state = this.state,
          pageSize = _state.pageSize,
          category = _state.category;

      var styles = require('./MobileBox.scss');
      var images = [];
      var cardsMobile = [];
      if (banners && banners.length > 0) {
        banners.map(function (item) {
          if (item.location === 'nearMe') {
            images.push({ image: item.image });
          }
        });
      }
      if (shops && shops.length > 0) {
        var length = shops.length > pageSize ? pageSize : shops.length;
        for (var index = 1; index < length; index++) {
          cardsMobile.push(_react2.default.createElement(_components.SmallCardMobile, { tracking: (0, _extends3.default)({}, this.props.tracking, { button: 'Detail Shop' }), manualTrack: this.props.manualTrack, key: index, shop: shops[index] }));
        }
      }
      if (!coords) {
        return _react2.default.createElement(
          'div',
          { className: styles.nearMeMobile },
          _react2.default.createElement(
            'div',
            { className: styles.headerBox },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement(
                  'h1',
                  {
                    className: styles.title,
                    onClick: function onClick() {
                      return _this2.handleChangeDiscoverNearby(category);
                    }
                  },
                  name
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.slogan },
              slogan
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.items },
            _react2.default.createElement(_components.Picture, {
              className: styles.imageLocation,
              src: _Images2.default.location.locationMobile,
              srcWebp: _Images2.default.location.locationMobileWebp
            })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: styles.nearMeMobile },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement(
                'h1',
                {
                  className: styles.title,
                  onClick: function onClick() {
                    return _this2.handleChangeDiscoverNearby(category);
                  }
                },
                name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.right },
              _react2.default.createElement(
                'div',
                { className: styles.seeMore, onClick: function onClick() {
                    return _this2.handleChangeDiscoverNearby(category, true);
                  } },
                'Xem th\xEAm'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.slogan },
            slogan
          ),
          images.length === 0 ? '' : _react2.default.createElement(_components.SwipeBanner, { tracking: (0, _extends3.default)({}, this.props.tracking, { button: 'Banner' }), manualTrack: this.props.manualTrack, images: images })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyBox },
          cardsMobile,
          _react2.default.createElement('div', { className: styles.lastItem })
        )
      );
    }
  }]);
  return NearMe;
}(_react.Component), _class2.propTypes = {
  name: _react.PropTypes.string,
  shops: _react.PropTypes.array,
  banners: _react.PropTypes.array,
  slogan: _react.PropTypes.string,
  getFeatured: _react.PropTypes.func.isRequired,
  province: _react.PropTypes.string,
  featuredLoaded: _react.PropTypes.bool,
  featuredLoading: _react.PropTypes.bool,
  isGeoAvailable: _react.PropTypes.bool,
  coords: _react.PropTypes.object,
  tracking: _react.PropTypes.object,
  changeSortType: _react.PropTypes.func,
  getOffset: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = NearMe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Home/NearMeMobile.js
// module id = 1604
// module chunks = 0